/* eslint react/require-default-props: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from 'components/Carousel';
import { homeCarouselVideoProcessor } from 'helpers/Processor/CarouselVideoProcessor';
import CarouselTheme from 'screens/Collection/Carousel.module.scss';
import CarouselTileTheme from 'screens/Collection/CarouselTile.module.scss';
import { FoxContentDensityBreakpoints } from 'screens/ContentDetail/ContentDetailHelper';
import Divider from 'components/Divider';

const LiveCarouselSection = ({
  accessToken,
  breakpoint,
  collectionCount,
  collectionVerticalPosition,
  dropdownHeadline,
  epgItems,
  favoritesManager,
  selectModalVideo,
  searchCompleted,
  setSearchCompleted,
  searchTerm,
  Style,
  renderImage,
  panel,
  panelCount,
}) => {
  const {
    addCarouselPlaceholders,
    allowScrollLock,
    applyInlineBackground,
    carouselLimit,
    roundArrows,
    slidesToScroll,
    showCarouselArrows,
    showTileMetadataOnHover,
    subtitleLines,
    truncateSubtitle,
    useScrollableDiv,
  } = FoxContentDensityBreakpoints[breakpoint];
  const headline = dropdownHeadline;
  const items = epgItems || _.get(panel, 'items.member') || _.get(panel, 'member');

  if (!items) return null;

  const collectionType = _.get(panel, 'collectionType');
  const panelType = _.get(panel, 'panelType');

  const getAdditionalVideoProcessProps = item => {
    if (selectModalVideo) {
      return {
        overridePlayButtonClick: () => {
          selectModalVideo(item);
        },
      };
    }
    return {};
  };

  const liveCarouselProps = {
    accessToken,
    addCarouselPlaceholders,
    allowScrollLock,
    applyInlineBackground,
    breakpoint,
    collectionCount,
    collectionVerticalPosition,
    favoritesManager,
    headline,
    isHoverStateV2: true,
    usePlayButtonThin: true,
    items,
    panelCount,
    processor: item =>
      homeCarouselVideoProcessor({
        collectionType,
        isHoverStateV2: true,
        panelType,
        video: item,
        ...getAdditionalVideoProcessProps(item),
      }),
    renderImage,
    roundArrows,
    searchCompleted,
    setSearchCompleted,
    searchTerm,
    showCarouselArrows,
    showTileMetadataOnHover,
    slidesToScroll,
    slidesToShow: carouselLimit,
    subtitleLines,
    truncateSubtitle,
    theme: CarouselTheme,
    tileTheme: CarouselTileTheme,
    useScrollableDiv,
  };

  return (
    <>
      <Carousel {...liveCarouselProps} />
      <Divider Style={Style} />
    </>
  );
};

LiveCarouselSection.propTypes = {
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string.isRequired,
  collectionCount: PropTypes.number,
  collectionVerticalPosition: PropTypes.number,
  Style: PropTypes.shape({}),
  disableScroll: PropTypes.func,
  dropdownHeadline: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  epgItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  favoritesManager: PropTypes.shape({}),
  selectModalVideo: PropTypes.func,
  searchCompleted: PropTypes.bool,
  setSearchCompleted: PropTypes.func,
  searchTerm: PropTypes.string,
  isSeasons: PropTypes.bool,
  panel: PropTypes.shape({}).isRequired,
  panelCount: PropTypes.number,
  renderImage: PropTypes.func,
};

export default React.memo(LiveCarouselSection);
